import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { body2, spacing, subtitle1, textColors } from 'ui/theme';

export const EmptyDataWrapper = styled.div`
  ${body2};
  align-items: center;
  display: flex;
  flex-direction: column;
  height: ${pxToRem(148)};
  margin-bottom: ${spacing.plusThreeQuarter};
  row-gap: ${spacing.quarter};
`;

export const EmptyDataTitle = styled.div`
  ${subtitle1}
`;

export const EmptyDataSubtitle = styled.div`
  color: ${textColors.textSecondary};
`;
